import { render, staticRenderFns } from "./DialogEditCourse.vue?vue&type=template&id=42ee950c"
import script from "./DialogEditCourse.vue?vue&type=script&lang=js"
export * from "./DialogEditCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports